import React from 'react'
import * as classes from './Enrole.module.scss'
import * as Yup from 'yup'
//import { JoinSubscribe } from '../../services/services'
import { useFormik } from 'formik'
import Link from '../../services/utility'
//import { FailureModalShow, SuccessModalShow } from '../../store/Action/Action'
import { useDispatch } from 'react-redux'

function EnroleButton() {
  const dispatch = useDispatch()
  const validationschema = Yup.object({
    email: Yup.string().email('Must be a valid email').required(),
  })

  const SubscribeFormik = useFormik({
    initialValues: {
      email: '',
    },
    // validationSchema: validationschema,
    // onSubmit: values => {
    //   Subscribeus(values.email)
    // },
  })

//   const Subscribeus = email => {
//     var postdata = {
//       email: email,
//     }
//     JoinSubscribe(postdata)
//       .then(res => {
//         if (res.data.email !== undefined) {
//           dispatch(
//             FailureModalShow({
//               show: true,
//               msg: res.data.email[0],
//             })
//           )
//         } else {
//           dispatch(
//             SuccessModalShow({
//               show: true,
//               msg: 'Subscribed',
//             })
//           )
//         }
//       })
//       .catch(error => {
//         dispatch(
//           FailureModalShow({
//             show: true,
//             msg: error.message,
//           })
//         )
//       })
//   }

  return (
    <div className={classes.Subscribe}>
      <div className="mainsec">
        <form onSubmit={SubscribeFormik.handleSubmit}>
          <h4>JOIN US, IN CHANGING THE FUTURE</h4>
          <p>
            Become an insider, win trips & access exclusive early member
            discounts.
          </p>
          <div className={classes.formSec}>
            {/* <input
              type="email"
              name="email"
              placeholder="example@ableaura.com"
              value={SubscribeFormik.values.email}
              onChange={e => {
                if (e.target.value.length <= 50) {
                  SubscribeFormik.setFieldValue('email', e.target.value)
                }
              }}
            /> */}
            {SubscribeFormik.touched.email && SubscribeFormik.errors.email && (
              <div className="errorSec">
                <p>{SubscribeFormik.errors.email}</p>
              </div>
            )}
            <button type="submit" className={`btnoutline ${classes.btn}`}>
              <Link to='/acedamyAuth' className="SubmitBtn">ENROLE NOW</Link>
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default EnroleButton